import mastercard from '../../assets/mastercard.svg';
import visa from '../../assets/visa.svg';
import applePay from '../../assets/apple_pay.svg';
import googlePay from '../../assets/google_pay.svg';

export const paymentMethods = [
    { icon: mastercard, name: 'Mastercard' },
    { icon: visa, name: 'Visa' },
    { icon: applePay, name: 'Apple Pay' },
    { icon: googlePay, name: 'Google Pay' },
];
